import { render, staticRenderFns } from "./Forma28.vue?vue&type=template&id=79976ad4&scoped=true&"
import script from "./Forma28.vue?vue&type=script&lang=js&"
export * from "./Forma28.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79976ad4",
  null
  
)

export default component.exports